import initAccessibleAccordions from '../../components/accessibleAccordion';

initAccessibleAccordions();
